import * as React from 'react';
import type {SettingsRouteQuery as SettingsRouteQueryType} from './__generated__/SettingsRouteQuery.graphql';

export interface SettingsContextValue {
	account: NonNullable<SettingsRouteQueryType['response']['viewer']>['account'];
	refetch: () => void;
}

const SettingsContext = React.createContext<SettingsContextValue | null>(null);

export function SettingsProvider({value, children}: {value: SettingsContextValue; children: React.ReactNode}) {
	return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

/** Replaces v6 `useOutletContext<SettingsOutletContext>()`. */
export function useSettingsContext(): SettingsContextValue {
	const ctx = React.useContext(SettingsContext);
	if (ctx == null) {
		throw new Error('useSettingsContext must be used within a SettingsProvider');
	}
	return ctx;
}
